// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getBranchConstants} from '../../../shared/repositories';

export const updateDemoRentalBranches = () =>
    dispatch => getBranchConstants()
        .then(data => dispatch({
            data,
            type: actions.UPDATE_DEMO_RENTAL_BRANCH_SUCCESS
        }));




// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/action-creators/branches.js